import { render, staticRenderFns } from "./uploadAudio.vue?vue&type=template&id=58e59dbe"
import script from "./uploadAudio.vue?vue&type=script&lang=js"
export * from "./uploadAudio.vue?vue&type=script&lang=js"
import style0 from "./uploadAudio.vue?vue&type=style&index=0&id=58e59dbe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_cache-lo_875f195a559ab6cb5ed9ea4190ad0331/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports